import React from "react";
import { IoMdStarOutline, IoMdStarHalf, IoMdStar } from "react-icons/io";

const StarRating = ({ name, value, setFieldValue }) => {
    const handleRating = (rating) => {
        setFieldValue(name, rating);
    };

    return (
        <div style={{ display: "flex", fontSize: "2rem", cursor: "pointer" }}>
            {[1, 2, 3, 4, 5].map((star) => {
                const halfStar = star - 0.5;

                return (
                    <span key={star} style={{ position: "relative", display: "inline-block" }}>

                        {/* <span className="stars" onClick={() => handleRating(halfStar)} style={{ position: "absolute", width: "50%" }}>
                            {value >= halfStar ? <IoMdStarHalf className="f" /> : <IoMdStarOutline className="l" />}
                        </span> */}

                        <span className="stars" onClick={() => handleRating(star)}>
                            {value >= star ? <IoMdStar className="f" /> : <IoMdStarOutline className="l" />}
                        </span>
                    </span>
                );
            })}
        </div>
    );
};

export default StarRating;